import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { GRAY, WHITE } from "../../constants/colors/hex";
export var _SeparatorWrapper = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transform: rotate(-90deg);\n  display: inline-flex;\n\n  svg {\n    * {\n      fill: ", ";\n    }\n  }\n"])), GRAY[10]);
export var _SeparatorWrapperWhite = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  transform: rotate(-90deg);\n  display: inline-flex;\n\n  svg {\n    * {\n      fill: ", ";\n    }\n  }\n"])), WHITE);
export var useStyles = makeStyles(function () {
  return createStyles({
    linkStyle: {
      color: WHITE,
      '&:hover': {
        color: WHITE
      }
    },
    titleStyle: {
      color: WHITE
    }
  });
});